import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';

import { dominioDemandaCirurgica } from '../../../../config/database';

export default function ModalProcedimentosIncluidosDemanda(props) {
  const [options, setOptions] = React.useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'left',
    },
    responsive: [
      {
        breakpoint: 450,
        options: {
          chart: {
            height: '350px',
            width: '350px',
          },
          legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'left',
            floating: false,
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: 300,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
              colors: undefined,
              useSeriesColors: false,
            },
            itemMargin: {
              horizontal: 8,
              vertical: 2,
            },
            onItemClick: {
              toggleDataSeries: true,
            },
            onItemHover: {
              highlightDataSeries: true,
            },
          },
        },
      },

      {
        breakpoint: 576,
        options: {
          chart: {
            height: '450px',
            width: '450px',
          },
          legend: {
            position: 'bottom',
            width: 400,
          },
        },
      },

      {
        breakpoint: 768,
        options: {
          chart: {
            height: '500px',
            width: '500px',
          },
          legend: {
            position: 'bottom',
            width: 400,
          },
        },
      },

      {
        breakpoint: 992,
        options: {
          chart: {
            height: '600px',
            width: '600px',
          },
        },
      },
    ],
  });
  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };

    dominioDemandaCirurgica
      .post(`/api/listarProcedimentosIncluidosDemanda`, dados)
      .then(response => {
        const config = {
          series: [],
          labels: [],
          dataLabels: {
            enabled: false,
          },
          legend: {},
          title: {
            text: '',
            offsetX: 0,
            align: 'center',
            style: {
              fontSize: '20px',
            },
          },
        };
        const series = response.data.map(dado => {
          return dado.quantidadedemandas;
        });
        const labels = response.data.map(dado => {
          return dado.Demanda_procedimentoPrincipal.substring(0, 50);
        });
        const sum = response.data
          .map(dado => {
            return dado.quantidadedemandas;
          })
          .reduce((partialSum, a) => partialSum + a, 0);
        config.series = series;
        config.labels = labels;
        config.title.text = `Total: ${sum}`;
        setOptions(config);
      });
  };

  useEffect(() => {
    updateCharts();
  }, []);

  return <Chart options={options} series={options.series} type="pie" width="70%" />;
}
